import { PaymentStatus } from './PaymentStatus';
import { SalesInvoiceStatus } from './SalesInvoiceStatus';

export interface SalesInvoice {
    id?: number;
    totalSale: number;
    status: string;
    isActive: boolean;
}

export interface SalesInvoicePaymentDataForm {
    id: number;
    client_name?: string;
    total: number;
    total_neto: string;
    total_tax: string;
    created_user?: string;
    last_modified_user?: string;
    created_at?: string;
    updated_at?: string;
}

export interface SalesInvoiceDataForm {
    id?: number;
    total_sale?: number;
    total_neto?: number;
    total_tax?: number;
    invoice_number?: string;
    payment_status?: PaymentStatus;
    payment_status_id?: number;
    payment_statuses_id?: number[];
    status?: string;
    status_label?: string;
    status_selected?: SalesInvoiceStatus;
    status_choices?: SalesInvoiceStatusRequestDataForm[];
    is_active?: boolean;
    created_user?: string;
    last_modified_user?: string;

    created_at?: string;
    updated_at?: string;

    issue_date?: string| '';
    due_date?: string| '';
    due_date_2?: string| '';
    folio?: string;

    number_of_payments?: number;
    payment_1_percentage?: number;
    payment_2_percentage?: number;
    payment_2_condition_id?: number;
    payment_2_condition_name?: string;
    payment_2_days?: number;

    client_id?: number | string;
    society_id?: number | string;

    client?: string;
    client_name?: string;
    client_rut?: string;
    client_address?: string;
    client_email?: string;

    society?: string;
    society_name?: string;
    society_rut?: string;
    society_address?: string;
    society_email?: string;

    // Datos de pago heredados de la orden de venta
    payment_method_id?: number;
    payment_method_name?: string;
    payment_condition_id?: number;
    payment_condition_name?: string;
    days?: number;
}

export const defaultSalesInvoiceDataForm: SalesInvoiceDataForm = {
    total_sale: 0,
    payment_status_id: 0,
};

export interface SalesInvoiceFilters {
    id?: number | null;
    total_sale?: number | null;
    status?: string | '';
    invoice_number?: string | '';
    client_name?: string | '';
    client_rut?: string | '';
    folio?: string | '';
    issue_date_from?: string | '';
    issue_date_until?: string | '';

    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export interface SalesInvoiceStatusRequestDataForm {
    id?: number | string;
    name?: number | string;
}
